// i9ReverificationUtils contains i9 reverification logic [i9 section 3]
// HARRI-18354

(function () {
    angular.module("harriApp")
        .factory('i9ReverificationUtils', function () {
            var expiryDocumentsMap = {
                "A":{
                    "PERMENANT": [
                        "FOREIGN_PASSPORT_TEMP_STAMP",
                        "FOREIGN_PASSPORT_TEMP_MRIV"
                    ],
                    "ALIEN_AUTH": [
                        "EMP_AUTH_DOC",
                        "FOREIGN_PASSPORT"
                    ]
                },
                "A_SECOND": {
                    "PERMENANT": [
                        "TEMP_I_551_STAMP",
                        "MACHINE_READABLE_IMMIGRANT_VISA"
                    ],
                    "ALIEN_AUTH": [
                        "FORM_I_94_A"
                    ]
                },
                "C": {
                    "US_CITIZEN": [
                        "NATIVE_AMERICAN_TRIPLE_DOC",
                        "EMPLOYMENT_AUTH_DHS"
                    ],
                    "NON_CITIZEN": [
                        "NATIVE_AMERICAN_TRIPLE_DOC",
                        "EMPLOYMENT_AUTH_DHS"
                    ],
                    "PERMENANT": [
                        "NATIVE_AMERICAN_TRIPLE_DOC",
                        "EMPLOYMENT_AUTH_DHS"
                    ],
                    "ALIEN_AUTH": [
                        "NATIVE_AMERICAN_TRIPLE_DOC",
                        "EMPLOYMENT_AUTH_DHS"
                    ]
                }
            };

            var reverificationExpiryDocumentsCodes = [
                'FOREIGN_PASSPORT_TEMP_STAMP',
                'FOREIGN_PASSPORT_TEMP_MRIV',
                'EMP_AUTH_DOC',
                'RIM_PASSPORT',
                'FSM_PASSPORT',
                'FOREIGN_PASSPORT_Form_I_94',
                'RECEIPT_I_94',
                'RECEIPT_I_94_REFUGEE',
                'EMPLOYMENT_AUTH_DHS',
                'RECEIPT_REPLACEMENT_EMP_AUTH_DOC',
                'RECEIPT_REPLACEMENT_FOREIGN_PASSPORT_Form_I_94',
                'RECEIPT_FSM_PASSPORT',
                'RECEIPT_RIM_PASSPORT',
                'RECEIPT_REPLACEMENT_SOCIAL_SECURITY_CARD',
                'RECEIPT_REPLACEMENT_BIRTH_CERTIFICATE',
                'RECEIPT_REPLACE_NATIVE_AMERICAN_TRIBAL',
                'RECEIPT_REPLACEMENT_EMPLOYMENT_AUTH_DHS',
                'RECEIPT_PERM_RESID_CARD'
            ];

            var i9ReverificationUtils = {
                // check if attachment is one of the document in expiryDocumentsMap
                isExpiryDocument: function (attachment, citizenship, listType) {
                    if (expiryDocumentsMap[listType] && expiryDocumentsMap[listType][citizenship]) {
                        for (var i in expiryDocumentsMap[listType][citizenship]) {
                            var docCode = expiryDocumentsMap[listType][citizenship][i];

                            if (attachment.code == docCode) {
                                return true;
                            }
                        }
                    }
                },
                isReverificationExpiryDocument: function (attachment) {
                    if (
                        attachment &&
                        reverificationExpiryDocumentsCodes.indexOf(attachment.code) > -1
                    ) {
                        return true;
                    }
                },
                // check if employee document list contains i9 documents
                // if yes, get the latest approved document
                getLatestI9Document: function (documentsList) {
                    var referencedDocument;

                    for (var i in documentsList) {
                        var document = documentsList[i];

                        if (document.document_lookup && document.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.I9) {
                            var i9Directory = document;

                            if (i9Directory.documentsList) {
                                for (var j in i9Directory.documentsList) {
                                    var i9Document = i9Directory.documentsList[j];

                                    if (i9Document.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.I9 && i9Document.state === 'APPROVED') {
                                        if (referencedDocument) {
                                            if (moment(i9Document.updated).isAfter(moment(referencedDocument.updated))) {
                                                referencedDocument = i9Document;
                                            }
                                        } else {
                                            referencedDocument = i9Document;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    return referencedDocument;
                },
                // check if employee document list contains i9 reverification documents
                // two types of i9 reverification documents:
                // i9 reverification with no i9 or i9 reverification with i9 referenced document
                // if yes, get the latest one
                // reverification doc used to prefill employee name if employee name changes
                getLatestI9ReverificationDocument: function (documentsList, referencedDocument) {
                    var i9ReverificationDocument;

                    if (referencedDocument) {
                        if (referencedDocument.referenceDocuments && referencedDocument.referenceDocuments.length) {
                            for (var i in referencedDocument.referenceDocuments) {
                                var document = referencedDocument.referenceDocuments[i];

                                if (document.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.I9_REVERIFICATION_SECTION_3) {
                                    if (i9ReverificationDocument) {
                                        if (moment(document.updated).isAfter(moment(i9ReverificationDocument.updated))) {
                                            i9ReverificationDocument = document;
                                        }
                                    } else {
                                        i9ReverificationDocument = document;
                                    }
                                }
                            }
                        }
                    } else {
                        for (var i in documentsList) {
                            var document = documentsList[i];

                            if (document.document_lookup && document.document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.I9) {
                                var i9Directory = document;

                                if (i9Directory.documentsList) {
                                    for (var j in i9Directory.documentsList) {
                                        if (i9Directory.documentsList[j].document_lookup.code === OnBoardingAPI.DOCUMENT_TYPE.I9_REVERIFICATION_SECTION_3) {
                                            if (i9ReverificationDocument) {
                                                if (moment(i9Directory.documentsList[j].updated).isAfter(moment(i9ReverificationDocument.updated))) {
                                                    i9ReverificationDocument = i9Directory.documentsList[j];
                                                }
                                            } else {
                                                i9ReverificationDocument = i9Directory.documentsList[j];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    return i9ReverificationDocument;
                },
                // check when reverify rules not applicable so a warning message will show for the employer
                // reverification rules:
                // * if employee has a reverification document check if has expiration_date
                // * check user attachment if trackable [from expiryDocumentsMap], check expiration_date based on rules
                // ** if attachment has expiration_date or
                // ** if citizenship type = ALIEN_AUTH and user select list A, A_SECOND or A_THIRD and attchment has alien_auth_expiration
                isReverificationRulesApplied: function (i9Document, reverificationDocument) {
                    var reverificationApplied = false;

                    if (reverificationDocument) {
                        if (
                            reverificationDocument.meta_data &&
                            i9ReverificationUtils.isReverificationExpiryDocument(reverificationDocument.meta_data.attachment_document, reverificationDocument.meta_data.expiration_date)
                        ) {
                            reverificationApplied = true;
                        }
                    } else if (i9Document.meta_data) {
                        if (i9Document.meta_data.userAttachments) {
                            for (var i in i9Document.meta_data.userAttachments) {
                                var attachment = i9Document.meta_data.userAttachments[i];

                                if (i9ReverificationUtils.isExpiryDocument(attachment, i9Document.meta_data.citizenship, attachment.list_type)) {
                                    if (attachment.expiration_date) {
                                        reverificationApplied = true;
                                        break;
                                    } else if (
                                        i9Document.meta_data.citizenship === 'ALIEN_AUTH' &&
                                        (attachment.list_type === 'A' || attachment.list_type === 'A_SECOND' || attachment.list_type === 'A_THIRD') &&
                                        !i9Document.meta_data.not_alien_auth_expiration &&
                                        i9Document.meta_data.alien_auth_expiration
                                    ) {
                                        reverificationApplied = true;
                                        break;
                                    }
                                }
                            }
                        }
                    }

                    return reverificationApplied;
                },
                // show reverify button only for US brands
                isReverificationButtonShown : function (cardData) {
                    return cardData.brand
                        && cardData.brand.document_set
                        && cardData.brand.document_set.country_code === 'US';
                }
            };

            return i9ReverificationUtils;
        });
})();